import React from 'react';
import { useQuery } from '@apollo/client/react';
import { Box, Pagination } from '@mui/material';
import { useError } from 'contexts/error';
import { usePaginate } from 'contexts/paginate';
import Loader from 'components/loader';
import SessionInfosQuery from 'queries/session_info/index';
import Index from 'components/session_info/index';
import DeleteAllButton from 'components/session_info/button/delete_all';

const IndexContainer = () => {
  const { page, onPageChange } = usePaginate();
  const setError = useError();
  const {
    data = { sessionInfos: { sessionInfos: [], perPage: 10 } },
    loading,
    refetch,
  } = useQuery(SessionInfosQuery, {
    variables: {
      page: page,
    },
    onError: () => {
      setError('error.session_info.index');
    },
  });

  const onRemove = () => {
    if (page > 1) {
      onPageChange(page - 1);
    } else {
      refetch();
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Box display="flex" justifyContent="right">
        <DeleteAllButton />
      </Box>
      <Index sessionInfos={data.sessionInfos.sessionInfos} onRemove={onRemove} />
      <Box display="flex" justifyContent="center">
        {data.sessionInfos.sessionInfosTotalPages > 1 && (
          <Pagination
            count={data.sessionInfos.sessionInfosTotalPages}
            page={page}
            onChange={(_e, nextPage) => {
              onPageChange(nextPage);
            }}
          />
        )}
      </Box>
    </>
  );
};

export default IndexContainer;
